import { render, staticRenderFns } from "./CheckBoxItem.vue?vue&type=template&id=8e1407ec&scoped=true"
import script from "./CheckBoxItem.vue?vue&type=script&lang=ts"
export * from "./CheckBoxItem.vue?vue&type=script&lang=ts"
import style0 from "./CheckBoxItem.vue?vue&type=style&index=0&id=8e1407ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1407ec",
  null
  
)

export default component.exports